export type MaybeAborted<T> =
    | {
          status: 'aborted';
      }
    | {
          status: 'ok';
          data: T;
      };

export function createAutoAbortHandler<T>(): (
    cb: Promise<T>,
) => Promise<MaybeAborted<T>> {
    let lastAbort = new AbortController();

    return async (promise) => {
        lastAbort.abort();
        const localAbort = new AbortController();
        lastAbort = localAbort;

        const data = await promise;
        if (!localAbort.signal.aborted) {
            return { status: 'ok', data };
        } else {
            return { status: 'aborted' };
        }
    };
}
